import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import KinoKlikIcon from "../../images/logo.png";
import KinoKlikIconPurple from "../../images/LogoPurple.png";
import { useTheme } from "../../context/ThemeContext";

function NavbarBrand({ isGrayBackground }) {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const isLight = theme === 'light';
    const usePurple = isGrayBackground || isLight;

    return (
        <div className="tw-z-40">
            <Link
                to="/"
                className="tw-flex tw-items-center tw-gap-2 tw-no-underline hover:tw-opacity-90 tw-transition-opacity"
            >
                <img
                    src={usePurple ? KinoKlikIconPurple : KinoKlikIcon}
                    alt={t("KinoKlik Logo")}
                    className="tw-ml-2 tw-h-14"
                />
                <span
                    style={{ fontFamily: "'Josefin Sans', sans-serif", letterSpacing: '0.08em' }}
                    className={`tw-hidden sm:tw-inline tw-text-lg tw-font-bold ${usePurple ? 'tw-text-[#712CB0]' : 'tw-text-white'}`}
                >
                    {t("KinoKlik")}
                </span>
            </Link>
        </div>
    );
}

export default NavbarBrand;
